module.exports = __webpack_public_path__ + "img/optionDel.bca5338d.svg";